var map = {
	"./address.en.json": "849d",
	"./archive.en.json": "b4ba",
	"./auth.en.json": "b7fc",
	"./common.en.json": "9047",
	"./documents.en.json": "9e3e",
	"./error.en.json": "7b41",
	"./general_information.en.json": "451e",
	"./main.en.json": "b3a0",
	"./navigation.en.json": "82ff",
	"./payroll.en.json": "af0a",
	"./period.en.json": "79cc",
	"./profile.en.json": "6706",
	"./requests.en.json": "ab18",
	"./router.en.json": "5931",
	"./sales_tax.en.json": "afec",
	"./taxation.en.json": "3177",
	"./util.en.json": "5e8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f33";